import { Flex, Typography } from "antd";
import { SectionWithTextSelection } from "./SectionWithTextSelection";
import { CSSProperties, Dispatch, Fragment, SetStateAction } from "react";
import { ExtendedSectionHighlight } from "../types";
import { Storyboard } from "pages/media/types";
import { postToIframe } from "../../animator/utils";
import { useHighlightsStore } from "../../animator/useHighlightsStore";

export const AnimatorScript = ({
  onScroll,
  newSectionHighlight,
  setNewSectionHighlight,
  onSelectionChange,
  style,
  isRTL = false,
  language,
}: {
  onScroll: (id: string) => void;
  newSectionHighlight?: ExtendedSectionHighlight;
  setNewSectionHighlight: Dispatch<SetStateAction<ExtendedSectionHighlight>>;
  onSelectionChange: (
    sectionId: string,
    updatedStoryboard: Storyboard
  ) => Promise<void>;
  style?: CSSProperties;
  isRTL?: boolean;
  language?: string;
}) => {
  const { highlightedStoryboard, setCurrentHighlight } = useHighlightsStore();
  const handleBlurHighlight = () => {
    // will reset the active highlight being more visible in the PDF viewer
    postToIframe({
      type: "highlight-blurred",
    });
    setCurrentHighlight(undefined);
  };

  return (
    <Flex vertical gap={20} onClick={() => handleBlurHighlight()} style={style}>
      {highlightedStoryboard?.sections.map((section) => {
        return (
          <Fragment key={section?.id}>
            <Typography.Title level={5} style={{ margin: 0 }}>
              {section?.topic}
            </Typography.Title>
            <SectionWithTextSelection
              sectionContentWithHL={section?.script?.content}
              handleScroll={onScroll}
              sectionId={section?.id}
              newSectionHighlight={newSectionHighlight}
              setNewSectionHighlight={setNewSectionHighlight}
              onSelectionChange={onSelectionChange}
              isRTL={isRTL}
              language={language}
            />
          </Fragment>
        );
      })}
    </Flex>
  );
};
